const RECEIPT_TYPES = {
  VARIABLE_TYPE: 'variable',
  FIXED_TYPE: 'fixed',
};

export default RECEIPT_TYPES;
